/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { CreateTagDto, TagResponse, UpdateTagDto } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Tags<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags tags
   * @name Create
   * @request POST:/tags
   * @secure
   */
  create = (data: CreateTagDto, params: RequestParams = {}) =>
    this.request<TagResponse, any>({
      path: `/tags`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags tags
   * @name FindAll
   * @request GET:/tags
   * @secure
   */
  findAll = (params: RequestParams = {}) =>
    this.request<TagResponse[], any>({
      path: `/tags`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags tags
   * @name FindOne
   * @request GET:/tags/{id}
   * @secure
   */
  findOne = (id: string, params: RequestParams = {}) =>
    this.request<TagResponse, any>({
      path: `/tags/${id}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags tags
   * @name UpdateDescription
   * @request PATCH:/tags/{id}
   * @secure
   */
  updateDescription = (
    id: string,
    data: UpdateTagDto,
    params: RequestParams = {},
  ) =>
    this.request<TagResponse, any>({
      path: `/tags/${id}`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags tags
   * @name Remove
   * @request DELETE:/tags/{id}
   * @secure
   */
  remove = (id: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/tags/${id}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
}
